import { atom } from 'jotai';
import { RemoteKnowledgeRouteProps } from 'lib-knowledge-remote-types/routes.types';

export type FeatureFlags = Pick<RemoteKnowledgeRouteProps, 'featureFlags'>;

export const featureFlagsAtom = atom<FeatureFlags>({
  featureFlags: {
    aiAutoTranslation: false,
    smartArticleCreateMultiConversation: false,
  },
});
